import axios from 'axios';

export interface ContractCreateData {
    RelationOid: string;
    ContractTypeDefinitionOid?: string;
    ContractStartDate?: string;
    ContractPeriod?: string;
    LastMaintenanceDate1?: string;
    AutoRenewContract?: boolean;
}

export interface ContractUpdateData {
    ContractTypeDefinitionOid?: string;
    ContractStartDate?: string;
    ContractPeriod?: string;
    LastMaintenanceDate1?: string;
    AutoRenewContract?: boolean;
}

function getHeaders(token?: string) {
    return { headers: { Authorization: `Bearer ${token}` } };
}

function toIsoOrUndefined(val: any): string | undefined {
    if (!val) return undefined;
    if (val instanceof Date) return val.toISOString();
    if (typeof val === 'string') return new Date(val).toISOString();
    return undefined;
}

export async function createContract(data: ContractCreateData, token?: string) {
    const payload = {
        ...data,
        ContractStartDate: toIsoOrUndefined(data.ContractStartDate),
        LastMaintenanceDate1: toIsoOrUndefined(data.LastMaintenanceDate1),
    };
    const res = await axios.post('/api/Contract/Create', payload, getHeaders(token));
    return res.data;
}

export async function updateContract(oid: string, data: ContractUpdateData, token?: string) {
    const payload = {
        ...data,
        ContractStartDate: toIsoOrUndefined(data.ContractStartDate),
        LastMaintenanceDate1: toIsoOrUndefined(data.LastMaintenanceDate1),
    };
    const res = await axios.put(`/api/Contract/Update/${oid}`, payload, getHeaders(token));
    return res.data;
}

export interface ContractPatchData {
    MaintenancePlanned?: boolean;
    LastMaintenanceDate?: string | Date;
    LastMaintenanceDate1?: string | Date;
}

export async function patchContract(oid: string, data: ContractPatchData, token?: string) {
    const payload = {
        ...data,
        LastMaintenanceDate: toIsoOrUndefined(data.LastMaintenanceDate),
        LastMaintenanceDate1: toIsoOrUndefined(data.LastMaintenanceDate1),
    };
    const res = await axios.patch(`/api/Contract/Patch/${oid}`, payload, getHeaders(token));
    return res.data;
}

export async function deleteContract(oid: string, token?: string) {
    const res = await axios.delete(`/api/Contract/Delete/${oid}`, getHeaders(token));
    return res.data;
}
